import { Delete, Get, getAPIUrl, Post } from "../../../../services/apiMethod";

export const BodytypeEndpoints = {
  getBodyTypeDetails: `/admin/getVehicleBodyType`,
  addBodyType: `/admin/addVehicleBodyType`,
  editBodyType:`/admin/editBodyType?bodyTypeId=`,
  deleteBodyType: `/admin/deleteBodyType?id=`,
};

export const getBodyTypeDetails = (param = "") => {
  const url = getAPIUrl(BodytypeEndpoints.getBodyTypeDetails, param);
  return Get(url);
};
export const addBodyType = (data, param = "") => {
  const url = getAPIUrl(BodytypeEndpoints.addBodyType, param);
  return Post(url, data);
};
export const editBodyType = (data, param = "") => {
  const url = getAPIUrl(BodytypeEndpoints.editBodyType, param);
  return Post(url, data);
};
export const deleteBodyType = (param = "") => {
  const url = getAPIUrl(BodytypeEndpoints.deleteBodyType, param);
  return Delete(url, param);
};
